import { render, staticRenderFns } from "./ServiceDesignAdvanced.vue?vue&type=template&id=84fcfabc&scoped=true&"
import script from "./ServiceDesignAdvanced.vue?vue&type=script&lang=js&"
export * from "./ServiceDesignAdvanced.vue?vue&type=script&lang=js&"
import style1 from "./ServiceDesignAdvanced.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fcfabc",
  null
  
)

export default component.exports